/*
 * @Description: 全局过滤器
 * @Autor: kangpeng
 * @Date: 2020-04-23 10:19:25
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-05-28 14:22:55
 */
const ellipsis = (value, num = 10) => {
    if (!value) return '';
    if (value.length > num) {
        return value.slice(0, num) + '...'
    }
    return value
}

const ellipsisPhone = (value) => {
    if (!value) return '';
    return value.slice(0, 3) + '****' + value.slice(7, 11)
}

export {
    ellipsisPhone,
    ellipsis
}